import React from "react";
import { BadgeContainer } from "./badge-new-feature.styles";
import { BadgeProps } from "./badge-new-feature.types";

export const Badge: React.FC<BadgeProps> = ({ label, size = "sm" }) => {
  return <BadgeContainer $size={size}>{label}</BadgeContainer>;
};
